import Auth from './auth.module'
import User from './user.module'
import Help from './help.module'
import Category from './category.module'
import product from './product.module'
import image from './image.module'
import photo from './photo.module'
import photoimage from './photoimage.module'
import branding from './branding.module'
import presentation from './presentation.module'
import advertisement from './advertisement.module'
import sellsheetCategory from './sellsheetCategory.module'
import sellsheet from './sellsheet.module'
import publicrelation from './publicrelation.module'
import video from './video.module'
import c1868Category from './c1868Category.module'
import c1868 from './c1868.module'
import Downloads from './downloads.module'
import Dashboard from './dashboard.module'

const modules = {
  Auth,
  User,
  Help,
  Category,
  product,
  image,
  photo,
  photoimage,
  branding,
  presentation,
  advertisement,
  sellsheetCategory,
  sellsheet,
  publicrelation,
  video,
  c1868Category,
  c1868,
  Downloads,
  Dashboard
}

export default modules



// WEBPACK FOOTER //
// ./src/store/modules/index.js